export const createAudioContext = (deviceId, kind) => {
    if ('audioinput' === kind) {
        return new AudioContext();
    }

    return new AudioContext({ sinkId: deviceId });
}
